// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"465":"f152d9c8","511":"8f5f7ed9"}[chunkId] + ".chunk.js";
};